"use client"

import { Skeleton } from "@/components/ui/skeleton"

const AllPostsSkeleton = () => {
  return (
    <div className="flex flex-col gap-0 w-full">
      {Array.from({ length: 10 }).map((_, idx) => (
        <div
          key={idx}
          className="flex sm:flex-row flex-col sm:gap-5 gap-2 sm:py-[26px] py-4 sm:px-2 w-full border-b border-dashed border-[#00000033]"
        >
          <Skeleton className="sm:w-[27.7%] w-full h-[132px] rounded flex-shrink-0" />
          <div className="flex flex-col justify-center sm:w-[72.3%] w-full gap-2">
            <Skeleton className="h-6 w-full rounded" />
            <Skeleton className="h-4 w-3/4 rounded" />
            <Skeleton className="h-3 w-24 rounded" />
          </div>
        </div>
      ))}
      {/* Pagination Skeleton */}
      <div className="flex justify-center gap-2 sm:mt-[1.625rem] mt-4">
        {Array.from({ length: 5 }).map((_, idx) => (
          <Skeleton key={idx} className="h-10 w-10 rounded" />
        ))}
      </div>
    </div>
  )
}

export default AllPostsSkeleton
